import { Dispatch } from 'redux'
import { api } from '../../Controllers/api'
import { Company, CompanyInput } from 'Companies/Types/types'
import { ProcoreToken } from 'Projects/Types/types'

export const COMPANY_LOADING = 'COMPANY_LOADING'
export const ERROR = 'ERROR'
export const EDIT_COMPANY = 'EDIT_COMPANY'
export const GET_COMPANY = 'GET_COMPANY'
export const GET_TOKEN = 'GET_TOKEN'

export interface CompanyLoadingAction {
  type: typeof COMPANY_LOADING
  loading: boolean
}

export interface ErrorAction {
  type: typeof ERROR
  loading: boolean
  error: string
}

export interface UpdateCompanyAction {
  type: typeof EDIT_COMPANY
  payload: { data: Company }
  loading: boolean
}

export interface GetCompanyAction {
  type: typeof GET_COMPANY
  payload: { data: Company }
  loading: boolean
}

export interface GetTokenAction {
  type: typeof GET_TOKEN
  payload: { data: ProcoreToken }
  loading: boolean
}

const companyLoading = (loading: boolean): CompanyLoadingAction => {
  return {
    type: COMPANY_LOADING,
    loading
  }
}

const error = (error: string): ErrorAction => {
  return {
    type: ERROR,
    loading: false,
    error
  }
}

const retrieveCompany = (data: Company): GetCompanyAction => {
  return {
    type: GET_COMPANY,
    payload: { data },
    loading: true
  }
}

const editedCompany = (data: Company): UpdateCompanyAction => {
  return {
    type: EDIT_COMPANY,
    payload: { data },
    loading: false
  }
}

const retrieveToken = (data: ProcoreToken): GetTokenAction => {
  return {
    type: GET_TOKEN,
    payload: { data },
    loading: false
  }
}

const getCompany = () => {
  return (dispatch: Dispatch<GetCompanyAction>) => {
    api.get('company').then(({ data }) => {
      dispatch(retrieveCompany(data))
    })
  }
}

const editCompany = (_id: string, company: CompanyInput) => {
  return (dispatch: Dispatch<CompanyLoadingAction | UpdateCompanyAction>) => {
    dispatch(companyLoading(true))
    api.put(`company/${_id}`, company).then(({ data }) => {
      dispatch(editedCompany(data))
    })
  }
}

const getToken = (clientId: string, clientSecret: string) => {
  return (dispatch: Dispatch<GetTokenAction | CompanyLoadingAction | ErrorAction>) => {
    dispatch(companyLoading(true))
    api
      .post('procore/token', {
        grant_type: 'client_credentials',
        client_id: clientId,
        client_secret: clientSecret
      })
      .then(({ data }) => {
        if (data) {
          dispatch(retrieveToken(data))
        } else {
          dispatch(error('Error fetching token'))
        }
      })
      .catch(err => console.error(err))
  }
}

export { editCompany, getCompany, getToken }
